"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var deprecated_timezones_1 = require("./deprecated-timezones");

function mapDeprecatedTimezones(timezone) {
  if (Object.keys(deprecated_timezones_1.deprecatedTimezones).some(function (key) {
    return key === timezone;
  })) {
    return deprecated_timezones_1.deprecatedTimezones[timezone];
  } else {
    return timezone;
  }
}

exports.mapDeprecatedTimezones = mapDeprecatedTimezones;